

window.addEventListener('scroll', function () {
  const objects = document.querySelectorAll('.scroll-in');

  const cb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('displayed');
        observer.unobserve(entry.target);
      }
    });
  }
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0
  }

  const io = new IntersectionObserver(cb, options);

  objects.forEach(object => {
    io.observe(object);
  });
});


window.addEventListener('DOMContentLoaded', () => {
  const objects = document.querySelectorAll('.scroll-in-img');

  const cb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        const target = entry.target;
        const parent = target.parentElement;

        const siblings = Array.from(parent.querySelectorAll('.scroll-in-img'));

        if (siblings.length > 1) {
          siblings.forEach((el, index) => {
            if (!el.classList.contains('displayed')) {
              el.style.setProperty('--delay', `${index * 0.35}s`);
              el.classList.add('displayed');
              observer.unobserve(el);
            }
          });
        } else {
          target.style.setProperty('--delay', '0s');
          target.classList.add('displayed');
          observer.unobserve(target);
        }
      }
    });
  };

  const options = {
   root: null,
    rootMargin: "-100px",
    threshold: 0
  };

  const io = new IntersectionObserver(cb, options);

  objects.forEach(object => {
    io.observe(object);
  });
});



window.addEventListener('DOMContentLoaded', () => {
  const objects = document.querySelectorAll('.scroll-in-img-menu');

  const cb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        const target = entry.target;
        const parent = target.parentElement;

        const siblings = Array.from(parent.querySelectorAll('.scroll-in-img-menu'));

        if (siblings.length > 1) {
          siblings.forEach((el, index) => {
            if (!el.classList.contains('displayed')) {
              el.style.setProperty('--delay', `${index * 0.1}s`);
              el.classList.add('displayed');
              observer.unobserve(el);
            }
          });
        } else {
          target.style.setProperty('--delay', '0s');
          target.classList.add('displayed');
          observer.unobserve(target);
        }
      }
    });
  };

  const options = {
   root: null,
    rootMargin: "-100px",
    threshold: 0
  };

  const io = new IntersectionObserver(cb, options);

  objects.forEach(object => {
    io.observe(object);
  });
});


const startIntersectionObserver = () => {
  const cb = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const target = entry.target;
        const parent = target.parentElement;
        const siblings = Array.from(parent.querySelectorAll(".instafeed-new-layout-item"));

        if (siblings.length > 1) {
          siblings.forEach((el, index) => {
            if (!el.classList.contains("displayed")) {
              el.style.setProperty("--delay", `${index * 0.1}s`);
              el.classList.add("displayed");
              observer.unobserve(el);
            }
          });
        } else {
          target.style.setProperty("--delay", "0s");
          target.classList.add("displayed");
          observer.unobserve(target);
        }
      }
    });
  };

  const options = {
    root: null,
    rootMargin: "-100px",
    threshold: 0,
  };

  const io = new IntersectionObserver(cb, options);

  const observe = () => {
    const items = document.querySelectorAll(".instafeed-new-layout-item");
    items.forEach((item) => {
      if (!item.classList.contains("displayed")) {
        io.unobserve(item); // 一度外してから再登録
        io.observe(item);
      }
    });
  };

  const items = document.querySelectorAll(".instafeed-new-layout-item");

  if (items.length > 0) {
    observe();
  } else {
    const mo = new MutationObserver(() => {
      const found = document.querySelectorAll(".instafeed-new-layout-item");
      if (found.length > 0) {
        mo.disconnect();
        observe();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  let resizeTimer;
  const ro = new ResizeObserver(() => {
    // 連続発火を間引く
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      observe();
    }, 200);
  });
  ro.observe(document.body);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startIntersectionObserver);
} else {
  startIntersectionObserver();
}